import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { CandidateService } from 'src/app/services/candidate.service';
import { LoaderServiceService } from 'src/app/services/loader-service.service';
import { CommonModule } from '@angular/common';

import { HeaderLatestComponent } from '../../home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from '../../peopleflow-footer/peopleflow-footer.component';
@Component({
  standalone: true,
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  imports: [CommonModule, HeaderLatestComponent, PeopleflowFooterComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class TermsAndConditionsComponent {
  [key: string]: any;
  constructor() {}

  scrollToTop() {}

  ngOnInit() {}

  getPolicyByName(name: any) {}
}
